module.exports = __webpack_public_path__ + "img/glass_grey.4476153b.png";